// Shared dedup + generic-name filter for character/casting/arc rows.
// Pre-fix jobs may contain duplicate or generic-label rows.

const GENERIC_NAME_RE =
  /^(el |la )?(protagonista|antagonista|narrador(a)?|prota|personaje( principal)?|principal|secundario)(\s*\(.*\))?$/i;

export function isGenericCharacterName(name: string | null | undefined): boolean {
  if (!name) return true;
  return GENERIC_NAME_RE.test(name.trim());
}

export function dedupByCharacterName<T extends { created_at?: string }>(
  rows: T[] | null | undefined,
  nameKey: keyof T
): T[] {
  if (!rows || rows.length === 0) return [];
  const map = new Map<string, T>();
  for (const row of rows) {
    const name = String(row[nameKey] ?? '').trim();
    if (!name || isGenericCharacterName(name)) continue;
    const key = name.toLowerCase();
    const prev = map.get(key);
    if (!prev || new Date(row.created_at ?? 0) > new Date(prev.created_at ?? 0)) {
      map.set(key, row);
    }
  }
  return Array.from(map.values());
}
